@defer (when form && (defaultForm || !isInvoice)) {
  <div
    class="flex-column"
    style="
      overflow: auto;
      height: 100%;
      max-width: 1400px;
    "
    [formGroup]="form"
  >
    @if (!isInvoice) {
      <div class="mat-h2">Rechnungsautomation</div>

      <div class="flex-row" style="gap: 2rem; align-items: center; padding-bottom: 1rem">
        <mat-form-field appearance="outline" class="semi-dynamic-width">
          <mat-label>Verzögerung (Tage)</mat-label>
          <input
            matInput
            type="number"
            formControlName="delay"
            (input)="limitDecimalPlaces($event, 0, 'delay')"
            (blur)="setToZeroIfEmpty($event, 'delay')"
          >
          @if (form.controls.delay?.hasError('min')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.min) }}</mat-error>
          }
        </mat-form-field>

        <mat-slide-toggle formControlName="autoarrange">
          Automatisch anordnen
        </mat-slide-toggle>

        <mat-slide-toggle formControlName="autocreate">
          Automatisch erstellen
        </mat-slide-toggle>
      </div>
    }

    @if (!isInvoice) {
      <div class="mat-h2">Mahnungskonditionen</div>

      <div class="flex-row space-between">
        <mat-form-field
          appearance="outline"
          class="semi-dynamic-width"
        >
          <mat-label>Zahlungsziel (Tage)</mat-label>
          <input
            matInput
            type="number"
            formControlName="period"
            (input)="limitDecimalPlaces($event, 0, 'period')"
            (blur)="setToZeroIfEmpty($event, 'period')"
          >
          @if (form.controls.period?.hasError('min')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.min) }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="semi-dynamic-width"
        >
          <mat-label>Mahngebühren (€)</mat-label>
          <input
            matInput
            type="number"
            step="0.01"
            formControlName="charge"
            (input)="limitDecimalPlaces($event, 2, 'charge')"
            (blur)="formatCharge($event)"
            (focus)="onChargeFocus($event)"
          >
          @if (form.controls.charge?.hasError('min')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.min) }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="semi-dynamic-width"
        >
          <mat-label>Verzugszinsen (%)</mat-label>
          <input
            matInput
            type="number"
            step="0.01"
            formControlName="defaultinterest"
            (input)="limitDecimalPlaces($event, 2, 'defaultinterest')"
            (blur)="setToZeroIfEmpty($event, 'defaultinterest')"
          >
          @if (form.controls.defaultinterest?.hasError('min')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.min) }}</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="flex-row space-between">
        <mat-form-field appearance="outline" class="semi-dynamic-width">
          <mat-label>Konto</mat-label>
          <input
            matInput
            formControlName="account"
            (input)="onInput($event)"
          >
          @if (form.controls.account?.hasError('consecutiveDollars')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="semi-dynamic-width">
          <mat-label>Kostenstelle</mat-label>
          <input
            matInput
            formControlName="costlocation"
            (input)="onInput($event)"
          >
          @if (form.controls.costlocation?.hasError('consecutiveDollars')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
          }
        </mat-form-field>
      </div>
    }

    <div class="flex-row space-between" formGroupName="header">
      <div class="flex-column semi-dynamic-width">
        <div class="mat-h2">
          Kopfzeile
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Titel</mat-label>

          <input
            matInput
            formControlName="title"
            [class]="getFormClass('header.title')"
            (input)="onInput($event)"
          >

          @if (form.controls.header?.controls.title?.hasError('consecutiveDollars')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
          }

          @if (differsFromDefault('header.title')) {
            <mat-icon
              matSuffix
              [svgIcon]="EsvgFiles.reset"
              (click)="resetFieldToDefault('header.title')"
            />
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Untertitel</mat-label>

          <input
            matInput formControlName="subtitle"
            [class]="getFormClass('header.subtitle')"
            (input)="onInput($event)"
          >

          @if (form.controls.header?.controls.subtitle?.hasError('consecutiveDollars')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
          }

          @if (differsFromDefault('header.subtitle')) {
            <mat-icon
              matSuffix
              [svgIcon]="EsvgFiles.reset"
              (click)="resetFieldToDefault('header.subtitle')"
            />
          }
        </mat-form-field>
      </div>

      <div class="flex-column semi-dynamic-width" style="margin-right: 5px">
        <div class="mat-h2 flex-row align-center">
          Logo

          @if (form.controls.header?.controls.logo) {
            <button mat-icon-button (click)="removeLogoForm()">
              <mat-icon [svgIcon]="EsvgFiles.delete"/>
            </button>
          }

          @if (differsFromDefault('header.logo.data') || differsFromDefault('header.logo.width')) {
            <button mat-icon-button (click)="resetFieldToDefault('header.logo')">
              <mat-icon [svgIcon]="EsvgFiles.reset"/>
            </button>
          }
        </div>

        @if (form.controls.header?.controls.logo) {
          <div formGroupName="logo">
            <div class="flex-column">
              <div class="flex-row" style="max-height: 135px; display: flex; overflow-x: auto;">
                <app-upload-wrapper
                  formControlName="data"
                  readAs="Image"
                  style="min-width: 120px; flex: 1 1 auto;"
                  accept="image/png"
                />

                @if (differsFromDefault('header.logo.data')) {
                  <button
                    mat-icon-button
                    (click)="resetFieldToDefault('header.logo.data')"
                  >
                    <mat-icon matSuffix [svgIcon]="EsvgFiles.reset"/>
                  </button>
                }

                @if (form.value.header.logo.data) {
                  <div style="width: 100px; flex: 0 0 auto;">
                    <img
                      style="height: 100%; width: 100%; object-fit: contain"
                      [src]="getLogoSrc()"
                      [alt]="form.value.header.logo.data.name"
                    >
                  </div>
                }
              </div>

              <mat-form-field>
                <mat-label>Breite</mat-label>

                <input
                  matInput
                  formControlName="width"
                  (input)="onInput($event)"
                  required
                >

                @if (differsFromDefault('header.logo.width')) {
                  <mat-icon
                    matSuffix
                    [svgIcon]="EsvgFiles.reset"
                    (click)="resetFieldToDefault('header.logo.width')"
                  />
                }
              </mat-form-field>
            </div>
          </div>
        } @else {
          <button
            mat-raised-button
            (click)="addLogoFormGroup()"
          >
            Logo hinzufügen
            <mat-icon
              [svgIcon]="EsvgFiles.add"
              class="add-icon"
            />
          </button>
        }
      </div>
    </div>

    <div class="flex-row space-between">
      <div class="flex-column semi-dynamic-width" formGroupName="letterbox_sender" style="min-width: 210px">
        <div class="mat-h2">Adressdaten</div>

        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>

          <input
            matInput formControlName="name"
            [class]="getFormClass('letterbox_sender.name')"
            (input)="onInput($event)"
          >

          @if (form.controls.letterbox_sender?.controls.name?.hasError('consecutiveDollars')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
          }

          @if (differsFromDefault('letterbox_sender.name')) {
            <mat-icon
              matSuffix
              [svgIcon]="EsvgFiles.reset"
              (click)="resetFieldToDefault('letterbox_sender.name')"
            />
          }
        </mat-form-field>

        <div class="flex-row">
          <mat-form-field class="semi-dynamic-width" appearance="outline">
            <mat-label>Straße</mat-label>

            <input
              matInput
              formControlName="street"
              [class]="getFormClass('letterbox_sender.street')"
              (input)="onInput($event)"
            >

            @if (form.controls.letterbox_sender?.controls.street?.hasError('consecutiveDollars')) {
              <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
            }

            @if (differsFromDefault('letterbox_sender.street')) {
              <mat-icon
                matSuffix
                [svgIcon]="EsvgFiles.reset"
                (click)="resetFieldToDefault('letterbox_sender.street')"
              />
            }
          </mat-form-field>

          <mat-form-field class="semi-dynamic-width" appearance="outline">
            <mat-label>Hausnummer</mat-label>

            <input
              matInput
              formControlName="street_number"
              [class]="getFormClass('letterbox_sender.street_number')"
              (input)="onInput($event)"
            >

            @if (form.controls.letterbox_sender?.controls.street_number?.hasError('consecutiveDollars')) {
              <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
            }

            @if (differsFromDefault('letterbox_sender.street_number')) {
              <mat-icon
                matSuffix
                [svgIcon]="EsvgFiles.reset"
                (click)="resetFieldToDefault('letterbox_sender.street_number')"
              />
            }
          </mat-form-field>
        </div>

        <div class="flex-row">
          <mat-form-field class="semi-dynamic-width" appearance="outline">
            <mat-label>PLZ</mat-label>

            <input
              matInput
              formControlName="postal_code"
              [class]="getFormClass('letterbox_sender.postal_code')"
              (input)="onInput($event)"
            >

            @if (form.controls.letterbox_sender?.controls.postal_code?.hasError('consecutiveDollars')) {
              <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
            }

            @if (differsFromDefault('letterbox_sender.postal_code')) {
              <mat-icon
                matSuffix
                [svgIcon]="EsvgFiles.reset"
                (click)="resetFieldToDefault('letterbox_sender.postal_code')"
              />
            }
          </mat-form-field>

          <mat-form-field class="semi-dynamic-width" appearance="outline">
            <mat-label>Ort</mat-label>

            <input
              matInput
              formControlName="city"
              [class]="getFormClass('letterbox_sender.city')"
              (input)="onInput($event)"
            >

            @if (form.controls.letterbox_sender?.controls.city?.hasError('consecutiveDollars')) {
              <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
            }

            @if (differsFromDefault('letterbox_sender.city')) {
              <mat-icon
                matSuffix
                [svgIcon]="EsvgFiles.reset"
                (click)="resetFieldToDefault('letterbox_sender.city')"
              />
            }
          </mat-form-field>
        </div>
      </div>

      <div class="flex-column semi-dynamic-width" style="margin-right: 5px">
        <div class="mat-h2">Kontaktinformationen</div>

        <div class="mat-h3 flex-row align-center">Kontaktblock 1
          @if (form.controls.contact_block1) {
            <button mat-icon-button (click)="removeNullableFormElement('contact_block1')">
              <mat-icon [svgIcon]="EsvgFiles.delete"/>
            </button>

            @if (contactBlockDiffersFromDefault('contact_block1')) {
              <button
                mat-icon-button
                matSuffix
                (click)="resetFieldToDefault('contact_block1')"
              >
                <mat-icon [svgIcon]="EsvgFiles.reset"/>
              </button>
            }
          }
        </div>

        @if (form.controls.contact_block1) {
          <div class="flex-column" formGroupName="contact_block1">
            <mat-form-field appearance="outline">
              <mat-label>Titel</mat-label>

              <input
                matInput
                formControlName="title"
                [class]="getFormClass('contact_block1.title')"
                (input)="onInput($event)"
              >

              @if (form.controls.contact_block1?.controls.title?.hasError('consecutiveDollars')) {
                <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
              }

              @if (differsFromDefault('contact_block1.title')) {
                <mat-icon
                  matSuffix
                  [svgIcon]="EsvgFiles.reset"
                  (click)="resetFieldToDefault('contact_block1.title')"
                />
              }
            </mat-form-field>

            <ng-container formArrayName="content">
              @for (content of contactBlock1Content.controls; track content.value) {
                <div [formGroupName]="$index" class="flex-row align-center">
                  <mat-form-field class="semi-dynamic-width" appearance="outline">
                    <input
                      matInput
                      formControlName="label"
                      [class]="getFormClass('contact_block1', $index, true)"
                      (input)="onInput($event)"
                    >
                    @if (contactBlock1Content.at($index).get('label')?.hasError('consecutiveDollars')) {
                      <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field class="semi-dynamic-width" appearance="outline">
                    <input
                      matInput
                      formControlName="value"
                      [class]="getFormClass('contact_block1', $index)"
                      (input)="onInput($event)"
                    >

                    @if (contactBlock1Content.at($index).get('value')?.hasError('consecutiveDollars')) {
                      <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
                    }

                    @if (getFormClass('contact_block1', $index) === 'overwritten'
                    && getLabelIndexInDefault('contact_block1', $index) !== -1) {
                      <mat-icon
                        matSuffix
                        [svgIcon]="EsvgFiles.reset"
                        (click)="resetContactBlockContentValueToDefault('contact_block1', $index)"
                      />
                    }
                  </mat-form-field>

                  <button mat-icon-button (click)="removeContactBlockContent('contact_block1', $index)">
                    <mat-icon matIconSuffix [svgIcon]="EsvgFiles.delete"/>
                  </button>
                </div>
              }
              <button mat-raised-button (click)="addContactBlockContent('contact_block1')">
                <mat-icon
                  style="display: inherit"
                  matIconPrefix
                  [svgIcon]="EsvgFiles.add"
                />

                Zeile hinzufügen
              </button>
            </ng-container>
          </div>
        } @else {
          <button
            mat-raised-button
            (click)="addContactBlockFormGroup('contact_block1')"
            class="add-contact-block-button"
          >
            Kontaktblock 1 hinzufügen

            <mat-icon
              [svgIcon]="EsvgFiles.add"
              class="add-icon"
            />
          </button>
        }

        <div class="flex-row align-center">
          @if (form.controls.contact_note) {
            <div class="flex-column" style="padding-top: 1rem; width: 100%;">
              <mat-form-field appearance="outline">
                <mat-label>Kontakthinweis</mat-label>
                <input
                  matInput
                  formControlName="contact_note"
                  [class]="getFormClass('contact_note')"
                  (input)="onInput($event)"
                >

                @if (form.controls.contact_note?.hasError('consecutiveDollars')) {
                  <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
                }

                <mat-icon
                  matIconSuffix
                  [svgIcon]="EsvgFiles.delete"
                  (click)="removeNullableFormElement('contact_note')"
                />

                @if (differsFromDefault('contact_note')) {
                  <mat-icon
                    matSuffix
                    [svgIcon]="EsvgFiles.reset"
                    (click)="resetFieldToDefault('contact_note')"
                  />
                }
              </mat-form-field>
            </div>
          } @else {
            <button mat-raised-button (click)="addContactNoteFormControl()" style="width: 100%">
              Kontakthinweis hinzufügen

              <mat-icon
                matIconSuffix
                [svgIcon]="EsvgFiles.add"
                class="add-icon"
              />
            </button>
          }
        </div>

        <div class="mat-h3 flex-row align-center">
          Kontaktblock 2
          @if (form.controls.contact_block2) {
            <button mat-icon-button (click)="removeNullableFormElement('contact_block2')">
              <mat-icon [svgIcon]="EsvgFiles.delete"/>
            </button>

            @if (contactBlockDiffersFromDefault('contact_block2')) {
              <button
                mat-icon-button
                matSuffix
                (click)="resetFieldToDefault('contact_block2')"
              >
                <mat-icon [svgIcon]="EsvgFiles.reset"/>
              </button>
            }
          }

        </div>
        @if (form.controls.contact_block2) {
          <div class="flex-column" formGroupName="contact_block2">
            <mat-form-field appearance="outline">
              <mat-label>Titel</mat-label>

              <input
                matInput
                formControlName="title"
                [class]="getFormClass('contact_block2.title')"
                (input)="onInput($event)"
              >

              @if (form.controls.contact_block2?.controls.title?.hasError('consecutiveDollars')) {
                <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
              }

              @if (differsFromDefault('contact_block2.title')) {
                <mat-icon
                  matSuffix
                  [svgIcon]="EsvgFiles.reset"
                  (click)="resetFieldToDefault('contact_block2.title')"
                />
              }
            </mat-form-field>

            <ng-container formArrayName="content">
              @for (content of contactBlock2Content.controls; track content.value) {
                <div [formGroupName]="$index" class="flex-row align-center">
                  <mat-form-field class="semi-dynamic-width" appearance="outline">
                    <input
                      matInput
                      formControlName="label"
                      [class]="getFormClass('contact_block2', $index, true)"
                      (input)="onInput($event)"
                    >
                    @if (contactBlock2Content.at($index).get('label')?.hasError('consecutiveDollars')) {
                      <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
                    }
                  </mat-form-field>

                  <mat-form-field class="semi-dynamic-width" appearance="outline">
                    <input
                      matInput
                      formControlName="value"
                      [class]="getFormClass('contact_block2', $index)"
                      (input)="onInput($event)"
                    >

                    @if (contactBlock2Content.at($index).get('value')?.hasError('consecutiveDollars')) {
                      <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
                    }

                    @if (getFormClass('contact_block2', $index) === 'overwritten'
                    && getLabelIndexInDefault('contact_block2', $index) !== -1) {
                      <mat-icon
                        matSuffix
                        [svgIcon]="EsvgFiles.reset"
                        (click)="resetContactBlockContentValueToDefault('contact_block2', $index)"
                      />
                    }
                  </mat-form-field>

                  <mat-icon
                    matIconSuffix
                    [svgIcon]="EsvgFiles.delete"
                    (click)="removeContactBlockContent('contact_block2', $index)"
                  />
                </div>
              }

              <button mat-raised-button (click)="addContactBlockContent('contact_block2')">
                Zeile hinzufügen
                <mat-icon
                  style="display: inherit"
                  matIconSuffix
                  [svgIcon]="EsvgFiles.add"
                />
              </button>
            </ng-container>
          </div>
        } @else {
          <button
            mat-raised-button
            (click)="addContactBlockFormGroup('contact_block2')"
            class="add-contact-block-button"
          >
            Kontaktblock 2 hinzufügen

            <mat-icon
              [svgIcon]="EsvgFiles.add"
              class="add-icon"
            />
          </button>
        }

        <div class="mat-h3 flex-row align-center">
          Patientenportal
          @if (form.controls.patient_portal) {
            <button mat-icon-button (click)="removeNullableFormElement('patient_portal')">
              <mat-icon [svgIcon]="EsvgFiles.delete"/>
            </button>
          }
        </div>

        <div class="flex-column">
          @if (form.controls.patient_portal) {
            <div class="flex-column" formGroupName="patient_portal">
              <mat-form-field appearance="outline">
                <mat-label>URL</mat-label>

                <input
                  matInput
                  formControlName="url"
                  [class]="getFormClass('patient_portal.url')"
                  (input)="onInput($event)"
                >

                @if (form.get('patient_portal.url')?.hasError('required')) {
                  <mat-error>
                    Die URL ist ein Pflichtfeld.
                  </mat-error>
                }

                @if (form.get('patient_portal.url')?.hasError('consecutiveDollars')) {
                  <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
                }

                @if (differsFromDefault('patient_portal.url')) {
                  <mat-icon
                    matSuffix
                    [svgIcon]="EsvgFiles.reset"
                    (click)="resetFieldToDefault('patient_portal.url')"
                  />
                }
              </mat-form-field>

              <div class="flex-row align-center">
                <mat-form-field class="semi-dynamic-width" appearance="outline">
                  <mat-label>Farben</mat-label>

                  <mat-select
                    formControlName="colors"
                    [class]="getFormClass('patient_portal.colors')"
                  >
                    <mat-option value="default">Standard</mat-option>

                    <mat-option value="drk">Deutsches Rotes Kreuz</mat-option>
                  </mat-select>
                </mat-form-field>

                @if (differsFromDefault('patient_portal.colors')) {
                  <mat-icon
                    matSuffix
                    [svgIcon]="EsvgFiles.reset"
                    (click)="resetFieldToDefault('patient_portal.colors')"
                  />
                }
              </div>
            </div>
          } @else {
            <button
              mat-raised-button
              (click)="addPatientPortalFormGroup()"
            >
              Patientenportal hinzufügen

              <mat-icon
                [svgIcon]="EsvgFiles.add"
                class="add-icon"
              />
            </button>
          }
        </div>
      </div>
    </div>

    <div class="mat-h2">Bank-Informationen</div>

    <div class="flex-column" formGroupName="bank_info" style="margin-right: 5px">
      <mat-slide-toggle labelPosition="before" formControlName="show_qr_code">
        QR-Code anzeigen
      </mat-slide-toggle>

      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>

        <input
          matInput
          formControlName="name"
          [class]="getFormClass('bank_info.name')"
          (input)="onInput($event)"
        >

        @if (form.controls.bank_info?.controls.name?.hasError('consecutiveDollars')) {
          <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
        }

        @if (differsFromDefault('bank_info.name')) {
          <mat-icon
            matSuffix
            [svgIcon]="EsvgFiles.reset"
            (click)="resetFieldToDefault('bank_info.name')"
          />
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>IBAN</mat-label>

        <input
          matInput
          formControlName="iban"
          [class]="getFormClass('bank_info.iban')"
          (input)="onInput($event)"
        >

        @if (form.controls.bank_info?.controls.iban?.hasError('consecutiveDollars')) {
          <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
        }

        @if (differsFromDefault('bank_info.iban')) {
          <mat-icon
            matSuffix
            [svgIcon]="EsvgFiles.reset"
            (click)="resetFieldToDefault('bank_info.iban')"
          />
        }

      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>BIC</mat-label>

        <input
          matInput
          formControlName="bic"
          [class]="getFormClass('bank_info.bic')"
          (input)="onInput($event)"
        >

        @if (form.controls.bank_info?.controls.bic?.hasError('consecutiveDollars')) {
          <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
        }

        @if (differsFromDefault('bank_info.bic')) {
          <mat-icon
            matSuffix
            [svgIcon]="EsvgFiles.reset"
            (click)="resetFieldToDefault('bank_info.bic')"
          />
        }

        @if (form.get('bank_info.bic').hasError('bicInvalid')) {
          <mat-error>
            Die BIC muss genau 8 oder 11 Zeichen lang sein, darf keine Sonderzeichen enthalten und die ersten 6 Zeichen
            dürfen keine Ziffern sein.
          </mat-error>
        }
      </mat-form-field>
    </div>

    @if (isInvoice) {
      <div class="mat-h2 flex-row align-center">
        Fußzeile

        @if (footerDiffersFromDefault()) {
          <button
            mat-icon-button
            matSuffix
            (click)="resetFooterToDefault()"
          >
            <mat-icon [svgIcon]="EsvgFiles.reset"/>
          </button>
        }
      </div>

      @if (hasFooterConsecutiveDollarsError()) {
        <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
      }

      <div class="flex-column">
        @if (form.controls.footer) {
          <div class="flex-row" formArrayName="footer">
            @for (footerColumn of footer.controls; track footerColumn.value; let i = $index) {
              <div class="flex-column semi-dynamic-width" [formGroupName]="i">
                <div class="flex-row centered">
                  <button mat-icon-button (click)="removeFooterColumn(i)">
                    <mat-icon matSuffix [svgIcon]="EsvgFiles.delete"/>
                  </button>
                </div>

                @for (footerElem of getFooterColumn(i).controls; track footerElem.value) {
                  <mat-form-field>
                    <input
                      matInput
                      [formControlName]="$index"
                      [class]="footerDiffersFromDefault() ? 'overwritten' : 'default'"
                      (input)="onInput($event)"
                    >

                    <button mat-icon-button (click)="removeFooterItem(i, $index)">
                      <mat-icon matSuffix [svgIcon]="EsvgFiles.delete"/>
                    </button>
                  </mat-form-field>
                }

                <div class="flex-row centered">
                  <button mat-icon-button (click)="addFooterItem(i)">
                    <mat-icon matSuffix [svgIcon]="EsvgFiles.add"/>
                  </button>
                </div>
              </div>
            }
            <button mat-icon-button (click)="addFooterColumn()">
              <mat-icon [svgIcon]="EsvgFiles.add"/>
            </button>
          </div>
        }
      </div>
    }

    @if (!isDefault) {
      <div class="flex-column">
        <div class="mat-h2 flex-row align-center">
          Erweiterte Konfiguration
        </div>

        @if (customOptions) {
          <ng-container formArrayName="custom_options">
            @for (customOption of customOptions?.controls; track customOption.value) {
              <div [formGroupName]="$index" class="flex-row align-center">
                <mat-form-field>
                  <mat-label>Schlüssel</mat-label>

                  <input
                    matInput
                    formControlName="key"
                    (input)="onInput($event)"
                  >
                  @if (customOptions.at($index).get('key')?.hasError('consecutiveDollars')) {
                    <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
                  }
                </mat-form-field>

                <mat-form-field>
                  <mat-label>Wert</mat-label>

                  <input
                    matInput
                    formControlName="value"
                    (input)="onInput($event)"
                  >
                  @if (customOptions.at($index).get('value')?.hasError('consecutiveDollars')) {
                    <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
                  }
                </mat-form-field>

                <mat-icon matIconSuffix [svgIcon]="EsvgFiles.delete" (click)="removeCustomOption($index)"/>
              </div>
            }
          </ng-container>
        }
        <button mat-icon-button (click)="createCustomOption()">
          <mat-icon [svgIcon]="EsvgFiles.add"/>
        </button>
      </div>
    }

    @if (!isInvoice && form.get('iscustomdunning').value) {
      <div class="flex-column"
           formGroupName="dunning"
      >
        <div class="mat-h2 flex-row align-center">
          Mahnungstext
        </div>

        <mat-form-field appearance="outline">
          <mat-label>Titel</mat-label>
          <input
            matInput
            formControlName="title"
            (input)="onInput($event)"
          >
          @if (form.controls.dunning?.controls.title?.hasError('consecutiveDollars')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Text 1. Block</mat-label>
          <textarea
            matInput
            formControlName="first_block_text"
            (input)="onInput($event)"
            rows="3"
          ></textarea>
          @if (form.controls.dunning?.controls.first_block_text?.hasError('consecutiveDollars')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Überschrift 2. Block</mat-label>
          <input
            matInput
            formControlName="second_block_title"
            (input)="onInput($event)"
          >
          @if (form.controls.dunning?.controls.second_block_title?.hasError('consecutiveDollars')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Text 2. Block</mat-label>
          <textarea
            matInput
            formControlName="second_block_text"
            (input)="onInput($event)"
            rows="3"
          ></textarea>
          @if (form.controls.dunning?.controls.second_block_text?.hasError('consecutiveDollars')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Grußformel</mat-label>
          <input
            matInput
            formControlName="outro"
            (input)="onInput($event)"
          >
          @if (form.controls.dunning?.controls.outro?.hasError('consecutiveDollars')) {
            <mat-error> {{ getErrorMessage(EErrorCodes.consecutiveDollars) }}</mat-error>
          }
        </mat-form-field>
      </div>
    }
  </div>
}
